import { motion } from "framer-motion";
import { MaskedLineInView } from "@/components/Reveal";

export default function PageHeader({ eyebrow, title, italicWord, description }) {
  return (
    <section className="relative pt-36 md:pt-44 pb-16 md:pb-24 border-b border-slate-100 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="text-xs uppercase tracking-[0.24em] text-blue-600 font-semibold"
        >
          / {eyebrow}
        </motion.div>
        <h1 className="mt-6 font-display text-5xl md:text-7xl font-light tracking-tight text-slate-900 leading-[1.02] max-w-5xl">
          <div className="block"><MaskedLineInView>{title}</MaskedLineInView></div>
          {italicWord && (
            <div className="block">
              <MaskedLineInView delay={0.12}>
                <span className="font-serif-editorial italic">{italicWord}</span>
              </MaskedLineInView>
            </div>
          )}
        </h1>
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.7 }}
            className="mt-10 max-w-2xl text-lg text-slate-600 leading-relaxed"
          >
            {description}
          </motion.p>
        )}
      </div>
    </section>
  );
}
